import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { VariablesService } from '../../shared/services';
import { ISipAssuredHeading, SIP_ASSURED_HEADING_DEFAULT_CONFIG } from './sip-assured-heading.model';

@Component({
  selector: 'app-sip-assured-heading',
  templateUrl: './sip-assured-heading.component.html',
  styleUrls: ['./sip-assured-heading.component.scss']
})
export class SipAssuredHeadingComponent implements OnInit {

  @Input() config: ISipAssuredHeading = {};
  user: any;
  qparam: any;

  constructor(
    private activateRoute: ActivatedRoute,
    public vars: VariablesService
  ) { }

  ngOnInit(): void {
    this.config = { ...SIP_ASSURED_HEADING_DEFAULT_CONFIG, ...this.config };
    this.qparam = this.activateRoute.snapshot.queryParams;
    this.vars.userData.subscribe((res) => {
      this.user = res;
    });
    if (this.vars.selected_partner) {
      this.config.warning_text = null;
    }
  }

}
